/**
 * This takes objects and returns an array
 * that Formulate can use for selects
 * Assumes: id, name
 */
export default {
	methods: {
		/**
		 * Returns only a value and label key relative to the object
		 *
		 * @param obj
		 * @param valueKey
		 * @param labelKey
		 * @returns {*[]}
		 */
		getOptions (obj, valueKey = 'id', labelKey = 'name') {
			let selectable = []

			if (! valueKey) {
				valueKey = 'id'
			}

			if (! labelKey) {
				labelKey = 'name'
			}

			for (const objKey in obj) {
				if (! obj.hasOwnProperty(objKey)) continue
				const item = obj[objKey]
				selectable.push({
					value: item[valueKey],
					label: item[labelKey]
				})
			}

			return selectable
		},

		/**
		 * Returns the original object with the added value and label keys
		 *
		 * @param obj
		 * @param valueKey
		 * @param labelKey
		 * @returns {*[]}
		 */
		populateOptions (obj, valueKey = 'id', labelKey = 'name') {
			let selectable = []

			if (! valueKey) {
				valueKey = 'id'
			}

			if (! labelKey) {
				labelKey = 'name'
			}

			for (const objKey in obj) {
				if (! obj.hasOwnProperty(objKey)) continue
				const item = obj[objKey]
				selectable.push({
					value: item[valueKey],
					label: item[labelKey],
					...obj[objKey]
				})
			}

			return selectable
		},

		/**
		 * Return options as an object with the value as the key
		 *
		 * @param obj
		 * @param valueKey
		 * @param labelKey
		 * @returns {{}}
		 */
		getOptionsObj (obj, valueKey = 'id', labelKey = 'name') {
			let selectable = {}

			if (! valueKey) {
				valueKey = 'id'
			}

			if (! labelKey) {
				labelKey = 'name'
			}

			for (const objKey in obj) {
				if (! obj.hasOwnProperty(objKey)) continue
				const item = obj[objKey]
				selectable[item[valueKey]] = item[labelKey]
			}

			return selectable
		},

		/**
		 * Used for b-form-select, returns only value and text keys from the object
		 *
		 * @param obj
		 * @param valueKey
		 * @param labelKey
		 * @returns {*[]}
		 */
		getOptionsFromObject (obj, valueKey = 'value', labelKey = 'text') { // b-form-select
			let selectable = []

			for (let objKey in obj) {
				if (! obj.hasOwnProperty(objKey)) continue

				if(objKey === 'null') {
					objKey = null
				}

				let item = {}
				item[valueKey] = objKey
				item[labelKey] = obj[objKey]

				selectable.push(item)
			}

			return selectable
		}
	}
}
